export default __webpack_public_path__ + "static/media/fa-solid-900.3eb06c70.woff2";